// import "react-phone-number-input/rrui.css";
import "react-phone-number-input/style.css";
import "react-phone-number-input/rrui.css";
import React, { Component } from "react";

import { FormattedMessage } from "react-intl";
import Phone, { formatPhoneNumber } from "react-phone-number-input";

class PhoneInput extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: this.props.value
    };
  }

  componentWillReceiveProps(props) {
    this.setState({ value: props.value });
  }

  handleFocus = event => {
    event.target.select();
  };

  render() {
    return (
      <FormattedMessage id="ids_EnterAPhoneNumber">
        {placeholder => (
          <Phone
            autoComplete="nope"
            country={this.props.country || undefined}
            className="form-control"
            placeholder={placeholder}
            // "Start typing a phone number"
            value={this.state.value}
            onChange={value => {
              this.setState({ value });
            }}
            onBlur={value => {
              // console.log("42 - value=", this.state.value && formatPhoneNumber("" + this.state.value, "", "International"));

              const newValue = this.state.value && formatPhoneNumber("" + this.state.value, "", "International");
              this.props.update({ value: newValue });
            }}
            onFocus={this.handleFocus}
          />
        )}
      </FormattedMessage>
    );
  }
}

export default PhoneInput;
